import axios from "axios";
import { SET_ERROR, SALE_ORDER, SALE_ORDERS, AVAILABLE_ITEMS, } from "../../types"

export const getSaleOrders = () => {
    return async (dispatch) => {
        await axios.get('/api/sale-orders/get-orders').then(response => {
            dispatch({
                type: SALE_ORDERS,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
}

export const AvailableItems = () => {
    return async dispatch => {
        await axios.get('/api/sale-orders/available-items').then(res => {
            dispatch({
                type: AVAILABLE_ITEMS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}


export const AddSaleOrder = (payload) => {
    return async (dispatch) => {
        await axios.post("/api/sale-orders/add-order", payload).then(response => {
            dispatch({
                type: SALE_ORDER,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};

export const UpdateSaleOrder = (payload) => {
    return async (dispatch) => {
        await axios.post('/api/sale-orders/update-order', payload).then(response => {
            dispatch({
                type: SALE_ORDER,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};

export const getOrderIdOutbound = async (orderId) => {
    let response = await axios.get(`api/items/get-outbound-by-order-id/${orderId}`);
    return response.data || []

}

export const getItemPurchaseOrder = async () => {
    let response = await axios.post(`api/items/get-item-by-purchase-order`);
    return response.data || []

}

export const allOrderList = async () => {
    let response = await axios.get('api/items/all-outbound-order-list');
    return response.data || []

}

